export default __webpack_public_path__ + "static/media/414.a1ffc17e.jpg";